<template>
  <form @submit.prevent="submit">
    <ToggleableCard :is-open="true" title="Διάρκεια ζωής πόντων">
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-half">
            <div class="field">
              <label class="label">Μέρες *</label>
              <div class="control">
                <input
                  v-model.number="form.expire_at"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.expire_at"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ToggleableCard>

    <ToggleableCard :is-open="true" title="Σύσταση φίλου (Referral)">
      <div class="card-content">
        <div class="field">
          <div class="settings-toggle">
            <ToggleButton
              :value="!!form.referral.enabled"
              :sync="true"
              :color="{ checked: '#22A684', unchecked: '#ff3860' }"
              :width="30"
              :height="15"
              @change="form.referral.enabled = $event.value"
            />
            <span>
              Referral: {{ form.referral.enabled ? 'Ενεργό' : 'Ανενεργό' }}
            </span>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-half">
            <div class="field">
              <label class="label">
                Πόντοι νέου πελάτη με qualifying order *
              </label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.points.referee_qualified"
                class="input"
                type="number"
                min="0"
                step="1"
                name="form.points.referee_qualified"
              />
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Πόντοι referrer με qualifying order *</label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.points.referrer_qualified"
                class="input"
                type="number"
                min="0"
                step="1"
                name="form.points.referrer_qualified"
              />
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Ελάχιστη qualifying παραγγελία (€) *</label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.referral.min_order_value"
                class="input"
                type="number"
                min="0"
                step="0.01"
                name="form.referral.min_order_value"
              />
              <p class="help">
                Η πρώτη παραγγελία του φίλου που φτάνει αυτό το ποσό.
              </p>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Έκπτωση κουπονιού (%) *</label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.referral.coupon_percent"
                class="input"
                type="number"
                min="0"
                step="0.01"
                name="form.referral.coupon_percent"
              />
              <p class="help">
                Νέος πελάτης: στην εγγραφή · referrer: στην ανταμοιβή · χωρίς
                ελάχιστη αξία · συνδυάζεται με τη βαθμίδα.
              </p>
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Διάρκεια κουπονιού (μήνες) *</label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.referral.coupon_months"
                class="input"
                type="number"
                min="0"
                step="1"
                name="form.referral.coupon_months"
              />
            </div>
          </div>
          <div class="column is-half">
            <div class="field">
              <label class="label">Ισχύς invite link (ημέρες) *</label>
              <input
                v-validate="'required|numeric|min_value:0'"
                v-model.number="form.referral.link_days"
                class="input"
                type="number"
                min="0"
                step="1"
                name="form.referral.link_days"
              />
            </div>
          </div>
        </div>

        <div class="field mt-3">
          <div class="settings-toggle">
            <ToggleButton
              :value="!!form.referral.registered_email_enabled"
              :sync="true"
              :color="{ checked: '#22A684', unchecked: '#ff3860' }"
              :width="30"
              :height="15"
              @change="form.referral.registered_email_enabled = $event.value"
            />
            <span>
              Email ενημέρωσης όταν εγγράφεται ο φίλος:
              {{
                form.referral.registered_email_enabled ? 'Ενεργό' : 'Ανενεργό'
              }}
            </span>
          </div>
        </div>
      </div>
    </ToggleableCard>

    <ToggleableCard :is-open="true" title="Πόντοι επισκέπτη (guest checkout)">
      <div class="card-content">
        <div class="field">
          <div class="settings-toggle">
            <ToggleButton
              :value="!!form.guest_claim.enabled"
              :sync="true"
              :color="{ checked: '#22A684', unchecked: '#ff3860' }"
              :width="30"
              :height="15"
              @change="form.guest_claim.enabled = $event.value"
            />
            <span>
              Guest claim:
              {{ form.guest_claim.enabled ? 'Ενεργό' : 'Ανενεργό' }}
            </span>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-half">
            <div class="field">
              <label class="label">
                Παράθυρο εγγραφής μετά την παραγγελία (ώρες) *
              </label>
              <input
                v-validate="'required|numeric|min_value:1|max_value:720'"
                v-model.number="form.guest_claim.window_hours"
                class="input"
                type="number"
                min="1"
                max="720"
                step="1"
                name="form.guest_claim.window_hours"
              />
            </div>
          </div>
        </div>
        <p class="help">
          Ο επισκέπτης βλέπει στη σελίδα ολοκλήρωσης και στο email της
          παραγγελίας τους πόντους που θα χάσει. Αν κάνει εγγραφή ή σύνδεση με
          το ίδιο email μέσα στο παράθυρο, οι πόντοι πιστώνονται με την
          παράδοση.
        </p>
      </div>
    </ToggleableCard>

    <ToggleableCard :is-open="true" title="Πόντοι">
      <div class="card-content">
        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Αντιστοιχία 1 ευρώ *</label>
              <div class="control">
                <input
                  v-model.number="form.points.order"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.order"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Εγγραφή στο Carespot *</label>
              <div class="control">
                <input
                  v-model.number="form.points.register"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.register"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Εγγραφή Newsletter *</label>
              <div class="control">
                <input
                  v-model.number="form.points.newsletter"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.newsletter"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Συμπλήρωση Προφίλ *</label>
              <div class="control">
                <input
                  v-model.number="form.points.profile"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.profile"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Σχολιασμός προιόντος *</label>
              <div class="control">
                <input
                  v-model.number="form.points.product"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.product"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-half">
            <div class="field">
              <label class="label">Σχολιασμός άρθρου *</label>
              <div class="control">
                <input
                  v-model.number="form.points.post"
                  :min="0"
                  :step="1"
                  class="input"
                  type="number"
                  name="form.points.post"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ToggleableCard>

    <div class="card">
      <div class="card-footer">
        <FormSubmit :is-saving="isSaving" @reset="reset" />
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import FormSubmit from '@/views/components/FormSubmit';
import ToggleableCard from '@/views/components/ToggleableCard';
import Notification from '@/views/components/Notification';

export default {
  components: {
    Notification,
    FormSubmit,
    ToggleableCard,
  },
  data: () => ({
    form: {},
    isSaving: false,
  }),
  computed: {
    ...mapGetters({
      loyalty: 'loyalty/getLoyalty',
      settings: 'loyalty/getSettings',
    }),
  },
  watch: {
    settings: {
      handler(newVal) {
        this.form = this.createData(newVal);
      },
      immediate: true,
    },
  },
  async created() {
    try {
      await this.getLoyalty();
    } catch (err) {
      console.log(err);
      this.$router.push('/error').catch(e => console.log(e));
    }
  },
  methods: {
    ...mapActions({
      getLoyalty: 'loyalty/getLoyalty',
      updateLoyalty: 'loyalty/updateLoyalty',
    }),
    createData(settings) {
      const defaults = {
        points: {
          referee_qualified: 10000,
          referrer_qualified: 10000,
        },
        referral: {
          enabled: false,
          min_order_value: 20,
          coupon_percent: 5,
          coupon_months: 3,
          link_days: 90,
          registered_email_enabled: true,
        },
        guest_claim: {
          enabled: true,
          window_hours: 24,
        },
      };

      return cloneDeep({
        ...settings,
        points: { ...defaults.points, ...(settings.points || {}) },
        referral: { ...defaults.referral, ...(settings.referral || {}) },
        guest_claim: {
          ...defaults.guest_claim,
          ...(settings.guest_claim || {}),
        },
      });
    },
    async submit() {
      try {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;

        await this.updateLoyalty({
          loyalty: {
            ...this.loyalty,
            settings: this.form,
          },
        });

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Οι τιμές αποθηκεύτηκαν',
        });
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      } finally {
        this.isSaving = false;
      }
    },
    reset() {
      this.form = this.createData(this.settings);

      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
.settings-toggle {
  align-items: center;
  display: inline-flex;
  gap: 0.6rem;
}
</style>
